export default "__VITE_ASSET__9m6Od4NJ__"